import { NumberField } from '@prismicio/types'

export const getPlayingThreshold = (
  isPortrait: boolean,
  content: {
    override_playing_threshold: boolean
    playing_threshold_portrait: NumberField
    playing_threshold_landscape: NumberField
    playback: 'on_click' | 'autoplay' | 'play_once'
  }
): number => {
  if (content.override_playing_threshold) {
    if (isPortrait) {
      if (
        content.playing_threshold_portrait &&
        content.playing_threshold_portrait > 0
      ) {
        return (content.playing_threshold_portrait / 100)
      }
    } else {
      if (
        content.playing_threshold_landscape &&
        content.playing_threshold_landscape > 0
      ) {
        return (content.playing_threshold_landscape / 100)
      }
    }
  }

  // default values based on playback type
  if (content.playback === 'autoplay') {
    return 0.1
  }

  if (content.playback === 'play_once') {
    return 0.4
  }

  return 0
}
